import Service from '../services/services';
import Geocode from '../services/google-geocode';

/**
 * Default model that all models extend from.
 * Methods attached are accessible by all models.
 */
class AccountModel {
    constructor() {
        this.firstRun = true;
        this.initialized = {
            //profile : {serviceRan : false,createNeeded : true}
        }
        this.error = {
            location:'',
            data:''
        }

        this.loader = {
            showLoader: false,
            loaderCount: 0
        };
    }
    /**
     * Get property from model
     * @param {string} property - Name of property on model
     * @returns {object}
     */
    get(property){
        return this[property];
    }
    /**
     * Create jquery array from form associated with selector and pass array to updateAllValues
     * @param {Object} model - The model matching the viewModel where the event was called from
     * @param {string} selector - The element used to trigger event
     * @param {string} modelProperty - Property of current model which will be updated
     * @param {string} session - Auth session
     * @param {string} serviceMethod - Method used to call service at specific endpoint
     * @param {Object} viewModel - ViewModel that event is attached to
     * @returns {promise}
     */
    getDataFromSelectorParent(model,selector,modelProperty,session, serviceMethod,viewModel){
        let $formInputs = jQuery(selector).closest('form').find('input:not(input[type="button"]), select');
        return this.updateAllValues(model,modelProperty,session, serviceMethod,viewModel,$formInputs, selector)
    }

    /**
	* Only digits, characters, underscores, and whitespace are acceptable.
	* Everything else gets replaced with an empty string to avoid unescaped
	* characters and invalid name attribute assignents.
	* @param {String} input value
	* @return {String}
	*/
    sanitizeInput(val) {
		return val.replace(/[^\w\s]-/gi, '');
	}

    /**
     * Recursively update sub-properties of model to values provided
     * @param {Object} model - The model matching the viewModel where the event was called from
     * @param {string} modelProperty - Property of current model which will be updated
     * @param {string} session - Auth session
     * @param {string} serviceMethod - Method used to call service at specific endpoint
     * @param {Object} viewModel - ViewModel that event is attached to
     * @param {array} valuesToUpdate - jQuery array of elements used to retrieve form values
     */
    updateAllValues(model, modelProperty, session, serviceMethod, viewModel, valuesToUpdate, selector, profileController){
        const _this = this;
        let value;
        valuesToUpdate.each(function(index){
            const $this = jQuery(this);
            let parts = $this.attr('name');
            if(parts === 'profile.student.college') {
                if ($this[0].checked) {
                    value = JSON.parse($this.val());
                }
            } else {
                if($this[0].type === 'checkbox') {
                    value = $this[0].checked;
                }
                else{
                    value = $this.val();
                }
                if(parts === 'profile.dateOfBirth.month' || parts === 'profile.dateOfBirth.day' || parts === 'profile.dateOfBirth.year' || parts === 'profile.student.graduation'){
                    value = parseInt(value, 10);
                }
            }
            _this.recursiveData(parts, value, model, model);
        });
        return _this.updateData(model, session, serviceMethod, modelProperty, viewModel, selector, profileController);
    }
    /**
     * Update model initialized property so on re-render a service get is performed.
     * Submit updated model to provided service method.
     * @param {Object} model - The model matching the viewModel where the event was called from
     * @param {string} session - Auth session
     * @param {Object} serviceMethod - Method used to call service at specific endpoint
     * @param {string} modelProperty - Property of current model which will be updated
     */
    updateData(model, session, serviceMethod, modelProperty, viewModel, controller, selector, profileController) {
        // update initialized and then call service with updated model
        if(typeof modelProperty === 'string') {
            // this.setInitialized(modelProperty,false,model.initialized[modelProperty].postNeeded)
            this.setInitialized(modelProperty, false, false);
            return Service[serviceMethod](model[modelProperty], session, model, viewModel, controller, selector, profileController);
        } else {
            this.setInitialized(modelProperty.prop, false, false);
            return Service[serviceMethod](model[modelProperty.temp], session, model, viewModel, controller, selector, profileController);
        }
    }
    /**
     * Submit address data to Google geocode service
     * @param {string} address - Address from form input
     * @param {string} serviceMethod - Method used to call service at specific endpoint
     */
    getGeocode(address, serviceMethod) {
        return Geocode.findAddress(address, serviceMethod);
    }

    /**
     * Build map with coordinates
     * @param {string} address - Coordinate values from Google based on form input
     */
    buildMap(address) {
        return Geocode.buildMap(address);
    }

    /**
     * Recursively loop through model properties to find matching property, then update value
     * @param {string} key - Name of model property/sup-property
     * @param {string} val - Value of form input
     * @param {Object} object - Model property to attach form values to
     * @param {Object} model - The model matching the viewModel where the event was called from
     */
    recursiveData(key, val, obj, model) {
        if (!obj) obj = data; //outside (non-recursive) call, use "data" as our base object
        var ka = key.split(/\./); //split the key by the dots
        if (ka.length < 2) {
            obj[ka[0]] = val; //only one part (no dots) in key, just set value
        } else {
            // create our "new" base obj if it doesn't exist
            if (!obj[ka[0]]) obj[ka[0]] = {};
            // remove the new "base" obj from string array, and hold actual object for recursive call
            obj = obj[ka.shift()];
            // join the remaining parts back up with dots, and recursively set data on our new "base" obj
            this.recursiveData(ka.join("."), val, obj, model);
        }
    }
    /**
     * Send session and model to specified service method
     * @param {string} method - Method used to call service at specific endpoint
     * @param {string} session - Auth session
     * @param {Object} model - The model matching the viewModel where the event was called from
     */
    getData(method, session, model, viewModel = {}) {
        if(typeof method !== 'undefined') {
            return Service[method](session, model, viewModel);
        }
    }
    /**
     * Set property/sub-property in model equal to data
     * @param {Object} data - New values to assign to property
     * @param {string} prop - Property which is going to be mutated
     * @param {boolean} multipleValues - Used to determine whether to dump all of data into the property
     */
    setData(data, prop, multipleValues = false) {
        if (multipleValues) {
            this[prop] = data;
        } else {
            if(typeof data === 'string') {
                this[prop] = data;
            } else {
                for(let subProp in data){
                    this[prop][subProp] = data[subProp];
                }
            }
        }

        return this;
    }
    /**
     * Update initialized property of model to values provided
     * @param {string} prop - The model property which will be mutated
     * @param {boolean} ran - Determines wheter the service call has been made for a particular property
     * @param {boolean} create - Determines whether a service call should be a post or put
     */
    setInitialized(prop, ran, create) {
        this.initialized[prop] = {
            serviceRan: ran,
            postNeeded: create
        };
    }

    /**
     * Attach validation messaging to the errors property
     * @param {Object} err - Error object returned from service
     * @param {string} message - Error message to display to user
     */
    attachValidationMessages(err, message) {
        this.errors.data = message;
        return Promise.resolve(this);
    }

    /**
     * Attach location for error to the errors property
     * @param {string} selector - Selector from event, used to determine location
     */

    attachErrorLocation(selector) {
        let locationName = selector == 'payment-and-address' ? 'payment-and-address' : jQuery(selector).closest('form').attr('name');
        this.errors.location = locationName;

        return Promise.resolve(this);
    }

    /**
     * Attach validation messaging to the errors property
     * Deprecated
     * @param {Object} error - Error object returned from service
     */
    revertForm(error) {
        if(error.entity.code === 'DUPLICATE_EMPLOYEE_PROFILE_FOUND') {
            this.editableProfile = this.tempProfile;
        } else if(error.url.endsWith('addresses')) {
            this.editableAddress = this.tempAddress;
        } else if(error.url.endsWith('payments')) {
            this.temp.ccImgSrc = "/images/paymenticons/icon_" + this.temp.creditCardDetail.cardType + ".gif";
        }

        return Promise.resolve(this);
    }

    /**
     * Reset deleted properties
     */
    disableTempStates() {
        this.deletedAddress = {
            siblingId: '',
            isFirst: false
        };
        this.deletedPayment = {
            siblingId: '',
            isFirst: false
        };

        return Promise.resolve(this);
    }

    /**
     * Attach location and data from service to errors property
     * @param {string} location - Location value to attach to errors property
     * @param {Object} data - Error data returned from service to attach to errors property
     */
    setErrors(location, data) {
        this.errors.location = location;
        this.errors.data = data;
    }

    /**
     * Reset temp property and turn the error viewState off
     * @param {Object} model - The model matching the viewModel where the event was called from
     * @param {string} selector - Selector from the event
     * @param {string} modelProperty - Property of current model which will be updated
     * @param {string} session - Auth session
     * @param {string} serviceMethod - Method used to call service at specific endpoint
     * @param {Object} viewModel - Viewmodel that event is attached to
	 * @param {Object} rt - Viewmodel value to reset temps
     */
    resetTemps(model, selector, modelProperty, session, serviceMethod, viewModel, rt) {
        if(rt) {
            this.temp = {};
            viewModel.updateViewState('showErrors', false);
        }

        return Promise.resolve(true);
    }

    /**
     * Initialize the preload animation for Account pages
     * @return {undefined} Returns nothing
     */
    createLoader() {
        if(typeof this.loader !== 'undefined' && typeof this.loader.loaderCount !== 'undefined') {
            this.loader.loaderCount++;
        } else {
            this.loader = {};
            this.loader.loaderCount = 1;
        }
        if(!this.loader.showLoader) {
            this.loader.showLoader = true;

            $.event.trigger({
                type: 'ATTACH_LOADER',
                payload: {}
            });
        }
    }

    /**
     * Destroy the preload animation if all loader-triggering events/API calls have finished
     * @return {undefied} Returns nothing
     */
    destroyLoader() {
        if(this.loader.showLoader) {
            this.loader.loaderCount--;

            if(this.loader.loaderCount === 0) {
                this.loader.showLoader = true;

                $.event.trigger({
                    type: 'REMOVE_LOADER',
                    payload: {}
                });
            }
        }
    }
}

export default AccountModel;
